export default "__VITE_ASSET__DidC1irG__"